const rootStyles = ({ spacing }) => ({
  '& .wrapper': {
    '& .form-group': {
      opacity: ({ loading }) => (loading ? 0 : 1),
    },
    opacity: ({ loading }) => (loading ? 0.5 : 1),
  },
  marginTop: spacing.md,
  position: 'relative',
});

export default rootStyles;
